/**
 * @file: util.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { OrgUserRoleType } from '@euler/model/enum';

const kRoleNameMap: { [p in OrgUserRoleType]: string } = {
  [OrgUserRoleType.Manager]: '门店经理',
  [OrgUserRoleType.ServiceAgents]: '服务顾问',
  [OrgUserRoleType.Technicians]: '服务技师',
  [OrgUserRoleType.QualityInspector]: '质检员',
  [OrgUserRoleType.Quoter]: '报价员',
  [OrgUserRoleType.Financial]: '财务',
  [OrgUserRoleType.AgentManager]: '代理商管理员',
  [OrgUserRoleType.Administrator]: '系统管理员',
  [OrgUserRoleType.Marketer]: '营销专员',
};

export const roleNameFromRoleType = (role: OrgUserRoleType) => {
  return kRoleNameMap[role] ?? '其他';
};
